<template>
  <div class="codigo-qr border p-0">
    <b-card v-if="data != null" class="">
      <h1 class="text-center my-5">
        Recolecciones capturadas
      </h1>
      <b-row class="pb-7 pt-7">
        <b-col>
          <label for="">Contratista</label>
          <b-form-select v-model="selectcontratista" :options="contratistaSelect" value-field="id" text-field="nombre_full" filter></b-form-select>
        </b-col>
        <b-col>
          <label for="">Cuadrillero</label>
          <b-form-select v-model="selectcuadrillero" :options="cuadrilleroSelect" value-field="id" text-field="nombre_full" filter></b-form-select>
        </b-col>
        <b-col>
          <label for="">Variedades</label>
          <b-form-select v-model="selectVariables" :options="variedadesSelect" value-field="id" text-field="descripcion" filter></b-form-select>
        </b-col>
        <b-col>
          <label for="">Materiales</label>
          <b-form-select v-model="selectMateriales" :options="materialesSelect" value-field="id" text-field="descripcion" filter></b-form-select>
        </b-col>
        <b-col cols="1" class="pt-8">
          <b-button variant="danger" @click="selectVariables=null;selectMateriales=null;selectcontratista=null;selectcuadrillero=null;">x</b-button>
        </b-col>
      </b-row>

      <v-client-table
        :columns="columns"
        :data="dataTable"
        :options="options"
        :theme="theme"
      />
    </b-card>

   <!-- <b-card class="py-5 mt-4" v-for="rec in recolecciones" :key="rec._id">
       <b-row>
         <b-col>
           <label>Cultivo:</label>
           <b-input :value='getCultivo(rec)' disabled/>
         </b-col>
       </b-row>

       <b-row class="mt-4">
         <b-col>
           <label>Cuadro:</label>
           <b-input :value='getCuadro(rec)' disabled/>
         </b-col>
         <b-col>
           <label>Variedad:</label>
           <b-input :value='getVariedad(rec)' disabled/>
         </b-col>
       </b-row>

       <b-row class="mt-4">
         <b-col>
           <label>Contratista:</label>
           <b-input :value='getContratista(rec)' disabled/>
         </b-col>
         <b-col>
           <label>Cuadrillero:</label>
           <b-input :value='getCuadrillero(rec)' disabled/>
         </b-col>
       </b-row>

       <b-row class="mt-4">
         <b-col>
           <label>Equipo:</label>
           <b-input :value='getEquipo(rec)' disabled/>
         </b-col>
         <b-col>
           <label>Matriz de materiales:</label>
           <b-input :value='getMaterial(rec)' disabled/>
         </b-col>
       </b-row>

       <b-row class="mt-4">
         <b-col>
           <label>Cantidad:</label>
           <b-input :value='rec.cantidad' disabled/>
         </b-col>
         <b-col>
           <label>Camion:</label>
           <b-input :value='getCamion(rec)' disabled/>
         </b-col>
       </b-row>

    </b-card> -->
  </div>
</template>

<script>
/* eslint-disable */
//import { QrcodeStream } from "vue-qrcode-reader";
import { mapState } from "vuex";
const spanishTable = require('../../../spanishTable.js');
import Vue from "vue";
import { ClientTable } from "vue-tables-2";
Vue.use(ClientTable);
import vSelect from 'vue-select';
export default {
  components: {
    vSelect
  },
  data: () => ({
    selectedOption: null,
    variedadId:null,
    materialesId:null,
    contratistaId:null,
    cuadrilleroId:null,
    selects:true,
    
    materialesSelect:[],
    contratistaSelect:[],
    cuadrilleroSelect:[],
    variedadesSelect:[],
    selectVariables: null,
    selectMateriales: null,
    selectcontratista: null,
    selectcuadrillero: null,



      
    theme: "bootstrap4",
    columns: ['contratista','cuadrillero','variedad','materiales','cantidad'],
    options: {
          texts:spanishTable,
          
          sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
          pagination: {
            chunk: 5,
            edge: true,
            nav: 'scroll'
          }
        },
  }),
  computed: {
    ...mapState({
      recolecciones: state => state.asistencias.recolecciones,
      data : state => state.asistencias.data
    }),
    total(){
      let total = 0
      this.recolecciones.map(x => {
          total+= parseFloat(x.cantidad)
      })
      return total
    },
    dataTable(){
      let data = []
      const self = this
      console.log(this.data, 'recolecciones');
      this.recolecciones.map(x=> {
         let row = {
            contratista : self.getContratista(x),
            cuadrillero : self.getCuadrillero(x),
            cantidad : x.cantidad,
            variedad : self.getVariedad(x),
            materiales : self.getMaterial(x),
         }
         if (this.selectVariables != null || this.selectMateriales != null || this.selectcontratista != null || this.selectcuadrillero != null ) {
          
           console.log(this.contratistaId ,this.selectcontratista);
           if (this.variedadId == this.selectVariables || this.materialesId == this.selectMateriales || this.contratistaId == this.selectcontratista || this.cuadrilleroId == this.selectcuadrillero) {
            
             data.push(row)
           }
         }else{
          data.push(row)
         }
      })
      data.push({
        contratista: null,
        cuadrillero : 'TOTAL',
        cantidad: self.total
      })
      this.selects=false
      return data
    },


    
    cuadros(){
      const cultivos = this.data.cultivos
      let cuadros = []
      cultivos.map(e => {
          e.variedads.map(x => {
            x.cuadros.map(c =>{
                cuadros.push(c)
            })
          })
      })
      return cuadros.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
    },
    equipos(){
      const cuadrilleros = this.cuadrilleros
      let equipos = []
      cuadrilleros.map(e => {
        e.cuadrilla_.map(x => {
            equipos.push(x.equipo)
        })
      })
      return equipos.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
    },
    cuadrilleros(){
      const contratistas = this.data.contratistas
      let usuarios = []
      contratistas.map(e => {
        e.cuadrilla_contratista.map(x => {
             usuarios.push(x.cuadrillero)
        })
      })
      return usuarios.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
    },
    materiales(){
      const cultivos = this.data.cultivos
      let pallet_tipos = []
      cultivos.map(e => {
          e.pallet_tipos.map(x => {
             pallet_tipos.push(x)
          })
      })
      return pallet_tipos.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
    },
    variedades(){
      const cultivos = this.data.cultivos
      let variedades = []
      cultivos.map(e => {
          e.variedads.map(x => {
             variedades.push(x)
          })
      })
      return variedades.filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
    }
  },
  watch: {
    selectVariables(){
      console.log(this.selectVariables);
    }
  },
  methods: {
    getCamion(d){
      const id = d.camionId
      const camiones = this.data.camiones
      const camion = camiones.find(x => x.id === id)
      return camion.numero
    },
    getCultivo(d){
      const id = d.cultivoId
      const cultivos = this.data.cultivos
      const cultivo = cultivos.find(x => x.id === id)
      return cultivo.descripcion
    },
    getMaterial(d){
      const id = d.palletTipoId
      const materiales = this.materiales
      const materiale = materiales.find(x => x.id === id)
      if (this.selects) {
        
        this.materialesSelect.push(materiale)
      }
      this.materialesId = materiale.id
      return materiale.id + ' - ' + materiale.descripcion
    },
    getContratista(d){
      const id = d.contratistaId
      const contratistas = this.data.contratistas
      const contratista = contratistas.find(x => x.id === id)
      if (this.selects) {

        this.contratistaSelect.push(contratista)
      }
      this.contratistaId = contratista.id
      return contratista != undefined ? contratista.nombre_full : ''
    },
    getCuadrillero(d){
      const id = d.cuadrilleroId
      const cuadrilleros = this.cuadrilleros
      const cuadrillero = cuadrilleros.find(x => x.id === id)
      if (this.selects) {
      
        this.cuadrilleroSelect.push(cuadrillero)
      }
      this.cuadrilleroId = cuadrillero.id
      return cuadrillero != undefined ? cuadrillero.nombre_full : ''
    },
    getEquipo(d){
      const id = d.equipoId
      const equipos = this.equipos
      const equipo = equipos.find(x => x.id === id)
      return equipo.descripcion
    },
    getCuadro(d){
      const id = d.cuadroId
      const cuadros = this.cuadros
      const cuadro = cuadros.find(x => x.id === id)
      return cuadro.clave_cuadro
    },
    getVariedad(d){
      const id = d.variedadId
      const variedades = this.variedades
      const variedad = variedades.find(x => x.id === id)
      if (this.selects) {
      
        this.variedadesSelect.push(variedad)
      }
      this.variedadId = variedad.id
      return variedad.descripcion
    }
  },
  created() {
  },
  mounted() {}
};
</script>

<style >
.error {
  font-weight: bold;
  color: red;
}
.codigo-qr .wrapper {
  padding-top: 0;
}
.codigo-qr .card-body {
  padding: 0;
}
.codigo-qr .wrapper video {
  border-radius: 0.42rem !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.VueTables__search{
  display: none!important;
}
</style>
